import { isSafariLowerThan15 } from '@utils';

/**
 * Add hack of emulating aspect ratio for platforms that do not support it
 */
export function createAspectRatioStyles(
  aspectRatio: number,
  width: number | string = '100%',
) {
  if (isSafariLowerThan15()) {
    const isWidthInPercent =
      typeof width === 'string' && width.includes('%');
    const parsedWidth =
      typeof width === 'string' ? parseFloat(width) : width;

    if (isWidthInPercent) {
      return {
        width,
        pb: `${parsedWidth / aspectRatio}%`,
      };
    }

    return {
      width,
      height: parsedWidth / aspectRatio,
    };
  }

  return {
    width,
    aspectRatio,
  };
}
